<template>
  <div>
    <el-divider class="cml-divider" content-position="center">间采产品审核权限</el-divider>
    <el-form
      class="cml-search-form"
      ref="listForm"
      :inline="true"
      size="mini"
    >
      <el-form-item label="登录名">
        <el-input
          v-model.trim="searchForm.account"
          @keyup.13.native="onSearch"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="花名">
        <el-input
          v-model.trim="searchForm.loginName"
          @keyup.13.native="onSearch"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button  @click="onReset">清空</el-button>
      </el-form-item>
    </el-form>
    <div class="cml-button-group">
      <el-button
        type="primary"
        @click="addBtn"
        v-hasPermission="'system-settings/product-approval-create'"
      >新增</el-button>
    </div>
    <CommonTable
      ref="CommonTableRef"
      :showPage="false"
      :showCheckbox="false"
      :loading="tableLoading"
      :tableHead="tableHead"
      :tableData="tableData"
      :tableParam="searchForm"
    >
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="deleteBtn(row)"
          v-hasPermission="'system-settings/product-approval-delete'"
          >删除</el-button
        >
        <el-button
          type="text"
          @click="updateBtn(row)"
          v-hasPermission="'system-settings/product-approval-update'"
          >修改</el-button
        >
      </template>
    </CommonTable>
    <el-dialog
      :title="formType === 'create' ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form :model="formData" label-width="140px" :rules="rules">
        <el-form-item label="花名" required prop="account">
          <b v-if="formType === 'update'">{{ formData.loginName }}</b>
          <el-select
            v-else
            v-model="formData.account"
            remote
            filterable
            placeholder="请选择花名"
            :remote-method="remoteMethod"
            @change="nameChange"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.account"
              :label="item.loginName"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品一级分类" prop="firstCategoryList" required>
          <DictSelect
            :multiple="true"
            type="cml_pd_first_category"
            :value="formData.firstCategoryList"
            @change-emit="val=>formData.firstCategoryList=val"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          type="primary"
          @click="createBtn"
          size="mini"
          :loading="saveLoading"
          >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CommonTable from '@/components/CommonTable';
import DictSelect from '@/components/DictSelect';

export default {
  name: 'approval-user',
  components: {
    CommonTable,
    DictSelect
  },
  data() {
    return {
      name: '',
      userOptions: [],
      dialogVisible: false,
      tableLoading: false,
      saveLoading: false,
      formData: {
        firstCategoryList: [],
        account: ''
      },
      formType: 'create',
      rules: {
        account: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        firstCategoryList: [
          { type: 'array', required: true, message: '不能为空', trigger: 'change' }
        ],
      },
      searchForm: {
        account: '',
        loginName: '',
      },
      tableData: {
        list: []
      },
      tableHead: [
        { prop: 'account', label: '登录名', width: 100, },
        { prop: 'loginName', label: '花名', width: 140, },
        { prop: 'firstCategoryName', label: '间采产品一级分类权限' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 100,
        }
      ]
    };
  },
  mounted() {
    this.getUser();
    this.$refs.CommonTableRef.changeHeight(35);
  },
  methods: {
    addBtn () {
      this.formType = 'create';
      this.dialogVisible = true;
      this.formData = {
        firstCategoryList: [],
        account: ''
      }
    },
    updateBtn (row) {
      this.formType = 'update';
      this.dialogVisible = true;
      this.formData = {
        ...row,
        firstCategoryList: row.firstCategoryList,
        account: row.account
      }
    },
    deleteBtn (row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.pdLibrary.pdAuditConfigDelete({
          id: row.id
        }).then(res => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.getUser();
        })
      })
    },
    nameChange (item) {
      if(!item.account) return false;
      this.formData.account = item.account
    },
    createBtn () {
      this.saveLoading = true;
      const url = this.formType === 'create' ? 'pdAuditConfigCreate' : 'pdAuditConfigUpdate';
      this.$http.pdLibrary[url](this.formData).then(res => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.formData = {
          firstCategoryList: [],
          account: ''
        }
        this.getUser();
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.saveLoading = false;
      })
    },
    remoteMethod (query) {
      if (!query.trim()) {
        this.userOptions = [];
        return false;
      }
      this.$http.user.getUserListAll({
        loginName: query
      }).then(res => {
        this.userOptions = res.data;
      })
    },
    onSearch() {
      this.getUser();
    },
    getUser() {
      this.tableLoading = true
      this.$http.pdLibrary.pdAuditConfigListAll(this.searchForm).then(result => {
        this.tableData.list = result.data;
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {this.tableLoading = false})
    },
    onReset() {
      this.searchForm.account = '';
      this.searchForm.loginName = '';
    }
  },
};
</script>
